import React from 'react'
import { FormattedMessage } from 'react-intl'

import Button from 'components/Button'

import { ValidationProposalModalFooter, ValidationProposalModalText } from '../style'

const PressureValidationModal = ({ toggleModal }) => {
  const closeModal = () => {
    toggleModal(false)
  }
  return (
    <div>
      <ValidationProposalModalText>
        <FormattedMessage id="pressureValidation" />
      </ValidationProposalModalText>
      <ValidationProposalModalFooter>
        <Button type="primary" onClick={closeModal}>
          <FormattedMessage id="goBack" />
        </Button>
      </ValidationProposalModalFooter>
    </div>
  )
}

export default PressureValidationModal
